import { useNavigate } from "react-router-dom";
import type { Theme } from "../../types";
import styles from "./Breadcrumb.module.scss";

interface BreadcrumbProps {
  theme: Theme;
  breadcrumbs: [string, string][];
}

const PAGE_PATHS: Record<string, string> = {
  home: "/",
  work: "/work",
  notes: "/notes",
  now: "/now",
  about: "/about",
};

export function Breadcrumb({ theme, breadcrumbs }: BreadcrumbProps) {
  const navigate = useNavigate();
  return (
    <div className={styles.wrapper} style={{ color: theme.muted }}>
      {breadcrumbs.map(([key, label], i) => (
        <span key={i} className={styles.item}>
          {i > 0 && (
            <span className={styles.sep} style={{ color: theme.muted }}>
              {"/"}
            </span>
          )}
          <span
            className={
              i < breadcrumbs.length - 1 ? styles.link : styles.current
            }
            style={{
              color: i === breadcrumbs.length - 1 ? theme.fg : theme.muted,
            }}
            onClick={
              i < breadcrumbs.length - 1
                ? () => navigate(PAGE_PATHS[key] ?? "/")
                : undefined
            }
          >
            {label}
          </span>
        </span>
      ))}
    </div>
  );
}
